var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"cmpbk black--text",attrs:{"id":"chkout-container"}},[_c('h1',{staticClass:"white--text"},[_vm._v("CHECKOUT")]),_c('h2',{staticClass:"white--text mt-10"},[_vm._v("Minimum Donation to Run $20")]),_c('paypal_button',{attrs:{"import":_vm.totalImport1,"description":_vm.description1},on:{"paypal_done":_vm.paypal_done}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }